import { useMutation } from '@tanstack/react-query';

import { customerApi } from '../api/customerApi';
import { ToastMessage } from '../components/ToastMessage';
import { NewCustomer } from '../types/customer';

export const useCreateNewCustomer = () => {
  const mutation = useMutation({
    mutationFn: (customerData: NewCustomer) =>
      customerApi.createNewCustomer(customerData),
    onSuccess: () => {
      ToastMessage({
        content: 'Cliente cadastrado com sucesso!',
        type: 'success',
      });
    },
    onError: () => {
      ToastMessage({
        content: 'Erro ao cadastrar cliente. Por favor, tente novamente!',
        type: 'error',
      });
    },
  });

  return {
    ...mutation,
    createNewCustomer: mutation.mutateAsync,
  };
};
